import { useLocation, useNavigate } from 'react-router-dom';
import styles from './BottomNav.module.css';

const tabs = [
  {
    id: 'home', label: 'Home', path: '/',
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path d="M2.75 9.25L11 2.75L19.25 9.25V19.25H14.25V14.25H7.75V19.25H2.75V9.25Z"
          stroke={active ? '#00B8A9' : '#9E9E9E'} strokeWidth="1.7" strokeLinejoin="round"/>
      </svg>
    )
  },
  {
    id: 'cards', label: 'Cards', path: '/cards',
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <rect x="2.75" y="5.5" width="16.5" height="11" rx="2" stroke={active ? '#00B8A9' : '#9E9E9E'} strokeWidth="1.7"/>
        <path d="M2.75 9H19.25" stroke={active ? '#00B8A9' : '#9E9E9E'} strokeWidth="1.7"/>
      </svg>
    )
  },
  {
    id: 'goals', label: 'Goals', path: '/goals',
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <circle cx="11" cy="11" r="8.25" stroke={active ? '#00B8A9' : '#9E9E9E'} strokeWidth="1.7"/>
        <circle cx="11" cy="11" r="4.5" stroke={active ? '#00B8A9' : '#9E9E9E'} strokeWidth="1.7"/>
        <circle cx="11" cy="11" r="1.5" fill={active ? '#00B8A9' : '#9E9E9E'}/>
      </svg>
    )
  },
  {
    id: 'more', label: 'More', path: '/more',
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <circle cx="11" cy="11" r="1.5" fill={active ? '#00B8A9' : '#9E9E9E'}/>
        <circle cx="5" cy="11" r="1.5" fill={active ? '#00B8A9' : '#9E9E9E'}/>
        <circle cx="17" cy="11" r="1.5" fill={active ? '#00B8A9' : '#9E9E9E'}/>
      </svg>
    )
  }
];

const BottomNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <nav className={styles.nav}>
      {tabs.map(({ id, label, path, icon }) => {
        const active = pathname === path;
        return (
          <button
            key={id}
            className={`${styles.tab} ${active ? styles.active : ''}`}
            onClick={() => navigate(path)}
            aria-label={label}
            aria-current={active ? 'page' : undefined}
          >
            {icon(active)}
            <span className={styles.label}>{label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
